import { render, staticRenderFns } from "./DateFormItem.vue?vue&type=template&id=383776db&scoped=true"
import script from "./DateFormItem.vue?vue&type=script&lang=js"
export * from "./DateFormItem.vue?vue&type=script&lang=js"
import style0 from "./DateFormItem.vue?vue&type=style&index=0&id=383776db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383776db",
  null
  
)

export default component.exports